/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { litellmCreateInstance } from "../funcs/litellmCreateInstance.js";
import { litellmIngestGuardrail } from "../funcs/litellmIngestGuardrail.js";
import { litellmListInstances } from "../funcs/litellmListInstances.js";
import { litellmRevokeInstance } from "../funcs/litellmRevokeInstance.js";
import { litellmRotateInstanceKey } from "../funcs/litellmRotateInstanceKey.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListInstancesResponseBody } from "../models/components/listinstancesresponsebody.js";
import { LitellmIngestResult } from "../models/components/litellmingestresult.js";
import { LitellmInstanceKeyResult } from "../models/components/litellminstancekeyresult.js";
import {
  CreateLiteLLMInstanceRequest,
  CreateLiteLLMInstanceSecurity,
} from "../models/operations/createlitellminstance.js";
import {
  IngestLiteLLMGuardrailRequest,
  IngestLiteLLMGuardrailSecurity,
} from "../models/operations/ingestlitellmguardrail.js";
import {
  ListLiteLLMInstancesRequest,
  ListLiteLLMInstancesSecurity,
} from "../models/operations/listlitellminstances.js";
import {
  RevokeLiteLLMInstanceRequest,
  RevokeLiteLLMInstanceSecurity,
} from "../models/operations/revokelitellminstance.js";
import {
  RotateLiteLLMInstanceKeyRequest,
  RotateLiteLLMInstanceKeySecurity,
} from "../models/operations/rotatelitellminstancekey.js";
import { unwrapAsync } from "../types/fp.js";

export class Litellm extends ClientSDK {
  /**
   * createInstance litellm
   *
   * @remarks
   * Provision a LiteLLM integration for a project and return its plaintext ingestion key once. Requires org:admin.
   */
  async createInstance(
    request: CreateLiteLLMInstanceRequest,
    security?: CreateLiteLLMInstanceSecurity | undefined,
    options?: RequestOptions,
  ): Promise<LitellmInstanceKeyResult> {
    return unwrapAsync(litellmCreateInstance(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * ingest litellm
   *
   * @remarks
   * Evaluates and captures a LiteLLM model request before it reaches the provider.
   */
  async ingestGuardrail(
    request: IngestLiteLLMGuardrailRequest,
    security?: IngestLiteLLMGuardrailSecurity | undefined,
    options?: RequestOptions,
  ): Promise<LitellmIngestResult> {
    return unwrapAsync(litellmIngestGuardrail(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listInstances litellm
   *
   * @remarks
   * List active and revoked LiteLLM integrations for a project. Plaintext keys are never returned. Requires org:admin.
   */
  async listInstances(
    request?: ListLiteLLMInstancesRequest | undefined,
    security?: ListLiteLLMInstancesSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListInstancesResponseBody> {
    return unwrapAsync(litellmListInstances(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * revokeInstance litellm
   *
   * @remarks
   * Revoke a LiteLLM integration and immediately invalidate its active key. Requires org:admin.
   */
  async revokeInstance(
    request: RevokeLiteLLMInstanceRequest,
    security?: RevokeLiteLLMInstanceSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(litellmRevokeInstance(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * rotateInstanceKey litellm
   *
   * @remarks
   * Atomically replace a LiteLLM integration key and return the new plaintext value once. Requires org:admin.
   */
  async rotateInstanceKey(
    request: RotateLiteLLMInstanceKeyRequest,
    security?: RotateLiteLLMInstanceKeySecurity | undefined,
    options?: RequestOptions,
  ): Promise<LitellmInstanceKeyResult> {
    return unwrapAsync(litellmRotateInstanceKey(
      this,
      request,
      security,
      options,
    ));
  }
}
